"use client";

import type { ReactNode } from "react";

type SelectionChipProps = {
  children: ReactNode;
  selected: boolean;
  onClick: () => void;
};

export function SelectionChip({ children, selected, onClick }: SelectionChipProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`w-full rounded-lg border px-5 py-4 text-left font-mono text-sm transition-all duration-200 ease-out ${
        selected
          ? "border-[#7B2FFF] bg-[#7B2FFF] text-[#F5F0E8]"
          : "border-[rgba(245,240,232,0.14)] bg-[rgba(18,16,15,0.58)] text-[#C9B99A] hover:bg-[rgba(18,16,15,0.72)]"
      }`}
    >
      {children}
    </button>
  );
}
